import { render, staticRenderFns } from "./ContainerWidget.vue?vue&type=template&id=279c0c3a&scoped=true&"
import script from "./ContainerWidget.vue?vue&type=script&lang=js&"
export * from "./ContainerWidget.vue?vue&type=script&lang=js&"
import style0 from "./ContainerWidget.vue?vue&type=style&index=0&id=279c0c3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279c0c3a",
  null
  
)

export default component.exports